import { Typography, Stack, Box } from '@mui/material';
import { CardBox, KeyArrowRightIconStyled, ListItemStyled } from './accountStyles';

interface AccountItemProps {
  title: string;
  open: () => void;
  icon: any;
  isVisible?: boolean;
  isDisabled?: boolean;
  isBold?: boolean;
}

export function AccountItem(props: AccountItemProps) {
  const { title, open, icon, isVisible = true, isDisabled, isBold } = props;

  return (
    <CardBox boxShadow={3} sx={{ display: !isVisible && 'none' }}>
      <ListItemStyled disabled={isDisabled} onClick={() => open()}>
        <Stack direction="row" alignItems="center" sx={{ margin: '5px' }}>
          <Box sx={{ width: '50px', color: 'secondary.main' }}>{icon}</Box>
          <Typography sx={{ fontWeight: isBold ? 'bold' : 'normal', flex: 1 }}>{title}</Typography>
          <KeyArrowRightIconStyled />
        </Stack>
      </ListItemStyled>
    </CardBox>
  );
}
